import routers, {ServerConfig, buildPath} from '@/config/routers';
import {addParamToCustomUrl} from '@/utils/kuQuery';
import KU_QUERY from '@/constants/common/searchParamKeys';

export const useGetVersionUrl = (repository: Repository, docGuid: string) => {
    return async (versionId: number | string, editionUrlId: string) => {
        const path = buildPath(routers.Knowledge.docEditionPath, {
            spaceGuid: repository.spaceGuid,
            groupGuid: repository.groupGuid,
            repositoryGuid: repository.repositoryGuid,
            docGuid: docGuid,
        });
        const url = ServerConfig.origin + path;
        const urlObj = addParamToCustomUrl(url, KU_QUERY.document.editionId, editionUrlId);
        return urlObj.href;
    };
};
